import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=0017a44c&scoped=true&"
import script from "./banners.vue?vue&type=script&lang=js&"
export * from "./banners.vue?vue&type=script&lang=js&"
import style1 from "./banners.vue?vue&type=style&index=1&id=0017a44c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017a44c",
  null
  
)

export default component.exports